import { ConditionalWrapper, warnAboutMissingStyles } from '@entur/utils';
import React from 'react';
import classNames from 'classnames';
import { Heading3, Paragraph, Label } from '@entur/typography';
import { ExternalIcon, ForwardIcon } from '@entur/icons';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var _excluded$5 = ["className", "as"];
var defaultElement$8 = 'div';
var Contrast = /*#__PURE__*/React.forwardRef(function Contrast(_ref, ref) {
  var className = _ref.className,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var Element = as || defaultElement$8;
  return React.createElement(ContrastContext.Provider, {
    value: true
  }, React.createElement(Element, _extends({
    className: classNames('eds-contrast', className),
    ref: ref
  }, rest)));
});
var ContrastContext = /*#__PURE__*/React.createContext(false);
var useContrast = function useContrast() {
  return React.useContext(ContrastContext);
};
var _excluded$4 = ["children", "className", "as"];
var defaultElement$7 = 'div';
var BaseCard = function BaseCard(_ref) {
  var children = _ref.children,
    className = _ref.className,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var Element = as || defaultElement$7;
  var classList = classNames('eds-base-card', className);
  return React.createElement(Element, _extends({
    className: classList
  }, rest), children);
};
var _excluded$3 = ["title", "children", "titleIcon", "compact", "className", "externalLink", "as"];
var defaultElement$6 = 'a';
var NavigationCard = function NavigationCard(_ref) {
  var title = _ref.title,
    children = _ref.children,
    titleIcon = _ref.titleIcon,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    className = _ref.className,
    _ref$externalLink = _ref.externalLink,
    externalLink = _ref$externalLink === void 0 ? false : _ref$externalLink,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var Element = as || defaultElement$6;
  var classList = classNames('eds-navigation-card', className, {
    'eds-base-card--red-line': compact,
    'eds-navigation-card--compact': compact
  });
  return React.createElement(BaseCard, _extends({
    as: Element,
    className: classList
  }, rest), !compact && titleIcon && React.createElement("div", {
    className: "eds-navigation-card__title-icon",
    "aria-hidden": "true"
  }, titleIcon), React.createElement("span", {
    className: "eds-navigation-card__title"
  }, compact && titleIcon && React.createElement("span", {
    className: "eds-navigation-card__title-icon-compact",
    "aria-hidden": "true"
  }, titleIcon), React.createElement(Heading3, {
    as: "span"
  }, title)), !compact && React.createElement(React.Fragment, null, React.createElement(Paragraph, null, children), externalLink && React.createElement(ExternalIcon, {
    "aria-label": "Ekstern lenke",
    className: "eds-navigation-card__external--not-compact"
  })), compact && externalLink && React.createElement(ExternalIcon, {
    "aria-label": "Ekstern lenke",
    className: "eds-navigattion-card__icon eds-navigation-card__external--compact"
  }), compact && !externalLink && React.createElement(ForwardIcon, {
    className: "eds-navigattion-card__icon eds-navigation-card__arrow-icon",
    "aria-hidden": "true"
  }));
};
var _excluded$2 = ["title", "description", "children", "className", "category", "style", "as", "headingLevel", "wholeCardAsElement", "hideArrow", "wrapperProps"];
var defaultElement$5 = 'a';
var MediaCard = function MediaCard(_ref) {
  var title = _ref.title,
    description = _ref.description,
    children = _ref.children,
    className = _ref.className,
    category = _ref.category,
    style = _ref.style,
    as = _ref.as,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? 'h2' : _ref$headingLevel,
    whole = _ref.wholeCardAsElement,
    hideArrow = _ref.hideArrow,
    wrapperProps = _ref.wrapperProps,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var Element = as || defaultElement$5;
  var Heading = headingLevel;
  var _wrapperProps = whole ? _extends({}, wrapperProps, rest) : _extends({}, wrapperProps);
  return React.createElement(BaseCard, _extends({
    className: classNames('eds-base-card', 'eds-media-card', className),
    style: style
  }, _wrapperProps), React.createElement("div", {
    className: "eds-media-card__media"
  }, children), React.createElement("div", {
    className: "eds-media-card__text"
  }, category && React.createElement(Label, {
    className: "eds-media-card__text__category"
  }, category), React.createElement(ConditionalWrapper, {
    condition: description !== undefined,
    wrapper: function wrapper(children) {
      return React.createElement(Heading, {
        className: "eds-media-card__text__title"
      }, children);
    }
  }, React.createElement(Element, _extends({
    tabIndex: 0,
    className: "eds-media-card__text__title-link"
  }, rest), title)), description !== undefined && React.createElement(Paragraph, null, description), !hideArrow && React.createElement(ForwardIcon, {
    className: "eds-media-card__arrow-icon",
    "aria-hidden": "true"
  })));
};
var _excluded$1 = ["children", "className", "max", "variant", "showZero", "invisible", "hide", "as", "type"];
var defaultElement$4 = 'span';
var Badge = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 99 : _ref$max,
    variant = _ref.variant,
    _ref$showZero = _ref.showZero,
    showZero = _ref$showZero === void 0 ? false : _ref$showZero,
    _ref$invisible = _ref.invisible,
    invisibleProp = _ref$invisible === void 0 ? false : _ref$invisible,
    _ref$hide = _ref.hide,
    hideProp = _ref$hide === void 0 ? false : _ref$hide,
    as = _ref.as,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'status' : _ref$type,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var Element = as || defaultElement$4;
  var computedHide = hideProp || invisibleProp || children === 0 && !showZero || children == null;
  var displayValue;
  if (typeof children === 'number') {
    displayValue = children > max ? max + "+" : children;
  } else {
    displayValue = children;
  }
  var classList = classNames(className, 'eds-badge', {
    'eds-badge--hide': computedHide,
    'eds-badge--show-zero': showZero
  }, "eds-badge--variant-" + variant, "eds-badge--type-" + type);
  return React.createElement(Element, _extends({
    className: classList,
    ref: ref
  }, rest), displayValue);
});
var defaultElement$3 = 'span';
var BulletBadge = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$3;
  // @ts-expect-error type error due to props not being BadgeOwnProps
  return React.createElement(Badge, _extends({
    as: Element
  }, props, {
    ref: ref,
    type: "bullet"
  }));
});
var defaultElement$2 = 'span';
var NotificationBadge = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$2;
  // @ts-expect-error type error due to props not being BadgeOwnProps
  return React.createElement(Badge, _extends({
    as: Element
  }, props, {
    ref: ref,
    type: "notification"
  }));
});
var defaultElement$1 = 'span';
var StatusBadge = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var Element = props.as || defaultElement$1;
  // @ts-expect-error type error due to props not being BadgeOwnProps
  return React.createElement(Badge, _extends({
    as: Element
  }, props, {
    ref: ref,
    type: "status"
  }));
});
var _excluded = ["className", "children", "compact", "as"];
var defaultElement = 'div';
var Tag = function Tag(_ref) {
  var className = _ref.className,
    children = _ref.children,
    compact = _ref.compact,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Element = as || defaultElement;
  var childrenArray = React.Children.toArray(children);
  var hasLeadingIcon = childrenArray.length > 1 && typeof childrenArray[0] !== 'string';
  var hasTrailingIcon = childrenArray.length > 1 && typeof childrenArray[childrenArray.length - 1] !== 'string';
  return React.createElement(Element, _extends({
    className: classNames('eds-tag', className, {
      'eds-tag--leading-icon': hasLeadingIcon,
      'eds-tag--trailing-icon': hasTrailingIcon,
      'eds-tag--compact': compact
    })
  }, rest), children);
};
warnAboutMissingStyles('layout', 'typography');
export { Badge, BaseCard, BulletBadge, Contrast, ContrastContext, MediaCard, NavigationCard, NotificationBadge, StatusBadge, Tag, useContrast };